const setLocalShowPrintBillButton = (val) => {
  localStorage.setItem("showPrintBillButton", val);
};
export default setLocalShowPrintBillButton;
